import BaseResource from './BaseResource'

export default class EnumerationTypes extends BaseResource {
  static endpoint = '/api/v1/enumerationtypes' // /profile
}
